<template>
  <div>
    <!--header start-->
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-searchbar
          v-model="searchValue"
          class="header-search"
          @keypress="handleKeyPress"
          placeholder="Find a cafe"
        ></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <!--header end -->
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonSearchbar } from "@ionic/vue";

export default defineComponent({
  name: "TheHeaderMenu",
  components: {
    IonHeader,
    IonToolbar,
    IonSearchbar,
  },
  data() {
    return {
      searchValue: "",
    };
  },
  methods: {
    handleKeyPress(event) {
      if (event.key === "Enter" && this.searchValue.trim() !== "") {
        this.$router.push({ path: "/search", query: { q: this.searchValue } });
      }
    },
    getUserType() {
      if (typeof window === "undefined" || !window.localStorage) {
        console.warn("localStorage is not available");
        return null;
      }
      try {
        return localStorage.getItem("userType");
      } catch (error) {
        console.warn("Failed to access localStorage:", error);
        return null;
      }
    },
  },
  async created() {
    // Only fetch cart orders for customers (not shop admins)
    const userType = this.getUserType();
    // Only fetch for explicit "customer" type
    if (userType === "customer") {
      try {
        await this.$store.dispatch("fetchCartOrders");
      } catch (error) {
        console.error("Failed to fetch cart orders:", error);
        // Cart fetch failure is non-critical - continue app initialization
      }
    } else if (!userType) {
      // Warn when userType is unset during initialization
      console.warn(
        "userType is not set during TheHeaderMenu initialization - user may be misclassified"
      );
    }
  },
});
</script>
<style scoped>
/* Header Container */
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

/* Search Bar */
.header-search {
  --background: #ffffff;
  --color: #1b1b1b;
  --placeholder-color: #828282;
  --icon-color: #1b1b1b;
  --clear-button-color: #828282;
  --border-radius: 8px;
  --box-shadow: none;
  --cancel-button-color: transparent;
  font-family: "Gilroy", sans-serif;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

/* Responsive adjustments for tablets */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .header-search {
    height: 56px;
    font-size: 16px;
  }
}
</style>
